import React, { Component } from 'react';
import { Form, Icon, Input, Button,Row,Col } from 'antd';
import {connect}  from 'react-redux'
import './styleLogin.css'
import { actionIniciarSesion } from '../../store/acciones/accionesUsuario';
import logonfh from '../../assets/images/logonfh.png'

class LoginPage extends Component {

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
          if (!err) {
            console.log(this.props)
             this.props.iniciarSesion(values)
            //  this.props.history.push('/')
          }
        });
      };
    render() {
        
        const { getFieldDecorator } = this.props.form;
        return (
            <Row type="flex" justify="center" align="middle" >
                <Col lg={12} md={12} sm={12} xs={24} className="cardLogin" >
                    <img src="http://www.nfh.com.mx/img/intro-carousel/4.jpg" alt="imagenLogin" />
                </Col>
                <Col lg={12} md={12} sm={12} xs={24} className="ColForm">
                    <div className="divForm">
                        <img src={logonfh} alt="logonfh" />
                        <Form onSubmit={this.handleSubmit} >
                            <Form.Item>
                                {getFieldDecorator('username', {
                                    rules: [{ required: true, message: 'Ingrese Usuario' }],
                                })(
                                    <Input
                                        prefix={<Icon type="user" />}
                                        placeholder="Nombre de usuario"
                                    />
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: 'Ingrese Contraseña!' }],
                                })(
                                    <Input
                                        prefix={<Icon type="lock" />}
                                        type="password"
                                        placeholder="Password"
                                    />
                                )}
                            </Form.Item>
                            <div className="Formulario">
                                <Button type="primary" htmlType="submit" className="login-form-button"> Iniciar Sesión</Button>
                            </div>
                        </Form>

                    </div>

                </Col>
            </Row>
        );
    }
}

const LoginForm = Form.create({ name: 'loginRegister' })(LoginPage);

const mapStateToProps = (state) => {
    return {

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        iniciarSesion: (values) => {
            dispatch(actionIniciarSesion(values))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)